export const DIALOG_ACTIONS = {
  ACTION: 'action',
  CANCEL: 'cancel',
  UNRAISED_ACTION: 'unraised-action',
};
